import dayjs from 'dayjs'
import { DurationUnitsObjectType } from 'dayjs/plugin/duration'
import { computed, ComputedRef, ref } from 'vue'


export interface SessionTimer {
  start: (initial? : number) => void;
  stop: () => void;
  duration: ComputedRef<string>
}

export function useSessionTimer (): SessionTimer {
  let intervalId: NodeJS.Timeout
  const timer = ref(0)

  function start (initial?: number) {
    if (initial) {
      timer.value = initial
    }
    intervalId = setInterval(() => {
      timer.value += 1
    }, 1000)
  }

  function stop () {
    if (!intervalId) return
    clearInterval(intervalId)
  }

  const duration = computed(() => {
    const hours = Math.floor(timer.value / 3600)
    const seconds = timer.value % 60
    const minutes = Math.floor((timer.value - (hours * 3600)) / 60)

    const durationUnits: DurationUnitsObjectType = {
      seconds,
      minutes,
    }

    let format = 'mm:ss'
    if (hours) {
      durationUnits.hours = hours

      format = `HH:${format}`
    }

    return dayjs.duration(durationUnits).format(format)
  })

  return {
    start,
    stop,
    duration,
  }
}
